import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

export const LSCNToolTipInfoComponent: React.FC = () => {
  const [t] = useTranslation()

  return (
    <>
      <StyledToolTipContent>{t(`cnToolTipContent.firstPart`)}</StyledToolTipContent>
      <StyledToolTipTitle>{t(`LSCNToolTipContent.title`)}</StyledToolTipTitle>
      <StyledToolTipContent>
        <StyledUL>
          <li>{t(`LSCNToolTipContent.list1`)}</li>
          <li>{t(`LSCNToolTipContent.list2`)}</li>
        </StyledUL>
      </StyledToolTipContent>
    </>
  )
}

export const LSCNToolTipInfo = observer(LSCNToolTipInfoComponent)

const StyledUL = styled.ul(
  () => css`
    padding: 0;
    padding-left: 18px;
  `
)

const StyledToolTipTitle = styled.div(
  ({ theme }) => css`
    padding: 4px;
    font-family: ${theme.fontFamily.Montserrat};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: ${theme.color.brandNavy};
  `
)

const StyledToolTipContent = styled.div(
  ({ theme }) => css`
    padding: 4px;
    font-family: ${theme.fontFamily.Montserrat};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    font-family: ${theme.fontFamily.Montserrat};

    color: ${theme.color.brandNavy};
  `
)
